/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Types from '@whitewater-guide/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveRiverMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type RemoveRiverMutation = {
  __typename?: 'Mutation';
  removeRiver?: string | null | undefined;
};

export const RemoveRiverDocument = gql`
  mutation removeRiver($id: ID!) {
    removeRiver(id: $id)
  }
`;
export type RemoveRiverMutationFn = Apollo.MutationFunction<
  RemoveRiverMutation,
  RemoveRiverMutationVariables
>;

/**
 * __useRemoveRiverMutation__
 *
 * To run a mutation, you first call `useRemoveRiverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRiverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRiverMutation, { data, loading, error }] = useRemoveRiverMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveRiverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveRiverMutation,
    RemoveRiverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveRiverMutation, RemoveRiverMutationVariables>(
    RemoveRiverDocument,
    options,
  );
}
export type RemoveRiverMutationHookResult = ReturnType<
  typeof useRemoveRiverMutation
>;
export type RemoveRiverMutationResult =
  Apollo.MutationResult<RemoveRiverMutation>;
export type RemoveRiverMutationOptions = Apollo.BaseMutationOptions<
  RemoveRiverMutation,
  RemoveRiverMutationVariables
>;
